import type { TOC } from '@ember/component/template-only'
import { t } from 'ember-intl'
import RouteTemplate from 'ember-route-template'
import { FluencySprintsTeachers } from 'teacher-ui-client/components/tables/fluency-sprints/teachers'
import type MathsFluencySprintsTeacherTeachersController from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/teacher/teachers/controller'
import type MathsFluencySprintsTeacherTeachersRoute from 'teacher-ui-client/reporting/ui-scope/maths/fluency-sprints/teacher/teachers/route'

interface Signature {
  Args: {
    model: ModelFor<MathsFluencySprintsTeacherTeachersRoute>
    controller: MathsFluencySprintsTeacherTeachersController
  }
}
export const MathsFluencySprintsTeacherTeachersPage: TOC<Signature> = <template>
  <FluencySprintsTeachers
    @items={{@model.teacherItems}}
    @isLoadingItems={{@model.loadTeacherDataTask.isRunning}}
    @onSortClick={{@controller.updateSorts}}
    @sortingConfig={{@controller.sortingConfig}}
    @exportable={{true}}
    @tableTooltipText={{t "reporting.maths.fluencySprints.teacher.tables.tooltips.teachers.table"}}
  />
</template>

export default RouteTemplate(MathsFluencySprintsTeacherTeachersPage)
